module.exports = __webpack_public_path__ + "img/notifications/chat-eab61eedc1d01f5a8d488f04725dfe8f.svg";